<template>
  <b-card>
    <BTable :fields="['id', 'name', 'assign']" :items="sortedCompanies">
      <template #name="{ item }">
        <router-link :to="{ name: 'companies.edit', params: { id: item.id } }">
          {{ item.name }}
        </router-link>
      </template>
      <template #assign="{ item }">
        <div v-if="item.assigned">
          <i class="icon-check text-success"></i>
        </div>
        <BButton v-else variant="primary" @click="assign(item.id)">
          {{ $t('bookings.assign') }}
        </BButton>
      </template>
    </BTable>
  </b-card>
</template>

<script>
export default {
  name: 'BookingSuitableCompanies',
  props: {
    companies: {
      type: Array,
      required: true,
    },
  },
  computed: {
    sortedCompanies() {
      return this.companies.toSorted((a, b) => {
        if (a.assigned === b.assigned) {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        }

        return a.assigned ? -1 : 1
      })
    },
  },
  methods: {
    assign(companyId) {
      this.$emit('assign', companyId)
    },
  },
}
</script>
